import React, { useEffect } from "react";
import styled from "styled-components";
import Loader from "../Loader/Loader";
import $ from "jquery";
import useWindowSize from "../../Hooks/shared/useWindowSize";

//usage
// footer={[
//     <button style={{marginRight: '12px', marginBottom: '0px'}} className="button">123</button>,
//     <button style={{marginBottom: '0px'}} className="button">Akkoord</button>
// ]}

const Modal = ({
    display,
    loading,
    children,
    onClose,
    loadText,
    size,
    title,
    footer
}) => {
    useEffect(() => {
        if (display) {
            $("body").addClass("stop-scrolling");
            $("body").bind("touchmove", function(e) {
                e.preventDefault();
            });
        }
        return function cleanup() {
            $("body").removeClass("stop-scrolling");
            $("body").unbind("touchmove");
        };
    }, [display]);

    // const { height } = useWindowSize();

    // const maxHeightContainer = () => {
    //     if (title && footer) {
    //         return height - (100 + 70 + 70);
    //     }
    //     if (title || footer) {
    //         return height - (100 + 70);
    //     }
    //     return height - 100;
    // };

    // const maxWidthContainer = () => {
    //     if (size === "large") {
    //         return "90%";
    //     }
    //     if (size === "medium") {
    //         return "60%";
    //     }
    //     if (size === "small") {
    //         return "30%";
    //     }
    //     return "90%";
    // };

    const onClickModal = e => {
        e.stopPropagation();
    };

    const onClickModalContainer = e => {
        onClose();
    };

    if (size === "large") {
        var classes = "w-11/12 md:w-10/12";
    } else {
        var classes = "w-11/12 md:w-3/4 lg:w-2/3 xl:w-1/2";
    }

    if (!display) {
        return null;
    }
    return (
        <div
            onMouseDown={onClickModalContainer}
            className="flex items-center justify-center fixed left-0 bottom-0 w-full h-full black-overlay z-40"
        >
            <div
                onMouseDown={onClickModal}
                style={{ maxHeight: "85vh" }}
                className={`bg-white rounded overflow-hidden ${classes}`}
            >
                <div
                    style={{ maxHeight: "85vh" }}
                    className="flex flex-col items-start p-4 relative overflow-y-scroll "
                >
                    {title && (
                        <div className="flex items-center w-full mb-4 pr-4">
                            <div className="text-gray-900 font-bold text-lg">
                                {title}
                            </div>
                        </div>
                    )}
                    <i
                        onClick={onClose}
                        style={{ right: "1rem", top: "1rem" }}
                        className="fas fa-times text-xl absolute cursor-pointer"
                    />

                    <hr />

                    {loading ? (
                        <div className="flex flex-col justify-center items-center w-full">
                            <Loader />
                            <h3>{loadText}</h3>
                        </div>
                    ) : (
                        children
                    )}

                    <hr />
                    {footer && (
                        <div className="ml-auto">
                            {footer.map(item => item)}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
export default Modal;

{
    /* <ModalContainer onMouseDown={onClickModalContainer} >
            <StyledModal style={{width: maxWidthContainer()}} onMouseDown={onClickModal}>
                <button
                    className="close-button"
                    onClick={onClose}
                    aria-label="Close modal"
                    type="button"
                >
                    <span aria-hidden="true">&times;</span>
                </button>

                {title && <ModalHeader>{title}</ModalHeader>}
                <ModalContent
                    style={{
                        maxHeight: maxHeightContainer()
                    }}
                >
                    {loading ? (
                        <LoadCon>
                            <Loader />
                            <h3>{loadText}</h3>
                        </LoadCon>
                    ) : (
                       children
                    )}
                </ModalContent>
                {footer && (
                    <ModalFooter>{footer.map(item => item)}</ModalFooter>
                )}
            </StyledModal>
        </ModalContainer> */
}

// const ModalContainer = styled.div`
//     position: fixed;
//     top: 0;
//     right: 0;
//     bottom: 0;
//     left: 0;
//     z-index: 1010;
//     overflow-y: auto;
//     -webkit-overflow-scrolling: touch;
//     padding: 15px 15px;
//     background: rgba(0, 0, 0, 0.6);
//     opacity: 0;
//     transition: opacity 0.15s linear;
//     padding: 50px 30px;
//     opacity: 1;
//     display: flex;
//     align-items: center;
//     @media screen and (max-width: 39.99875em) {
//         padding: 30px 12px;
//     }

// `;

// const StyledModal = styled.div`
//     position: relative;
//     box-sizing: border-box;
//     margin: 0 auto;
//     width: 600px;
//     max-width: calc(100% - 0.01px) !important;
//     background: #fff;
//     opacity: 0;
//     transform: translateY(-100px);
//     transition: 0.3s linear;
//     transition-property: opacity, transform;
//     opacity: 1;
//     transform: translateY(0);
//     @media screen and (max-width: 39.99875em) {
//       width: 100% !important;
//     }
// `;

// const ModalHeader = styled.div`
//     height: 70px;
//     margin-top: 0;
//     padding: 15px 30px;
//     background: #fff;
//     border-bottom: 1px solid #e5e5e5;
//     display: flex;
//     align-items: center;
//     h1, h2, h3, h4, h5, h6, p, span, a{
//         margin: 0px;
//     }
// `;
// const ModalContent = styled.div`
//     min-height: 150px;
//     overflow: auto;
//     padding: 30px 30px;
//     &::before {
//         content: "";
//         display: table;
//     }
// `;

// const ModalFooter = styled.div`
//     height: 70px;
//     text-align: right !important;
//     padding: 15px 30px;
//     background: #fff;
//     border-top: 1px solid #e5e5e5;
//     display: flex;
//     align-items: center;
//     justify-content: flex-end;
// `;

// const LoadCon = styled.div`
//     min-width: 200px;
//     min-height: 200px;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     flex-direction: column;
//     padding: 24px;
//     h1 {
//         color: white;
//     }
// `;
